import api from '../api'

const baseUrl = '/academy/api/AdminCareer'

const skillUpCareerProvider = {
  getCareer(id) {
    return api.get(`${baseUrl}/AdminCareerDetail/${id}`)
  },

  addCareer(params) {
    return api.post(`${baseUrl}/AddCareer`, params)
  },

  updateCareer(params = {}) {
    return api.put(`${baseUrl}/EditCareer`, params)
  },

  deleteCareer(params) {
    return api.delete(`${baseUrl}/Delete/${params}`)
  },

  getInputs() {
    return api.get(`${baseUrl}/Input`)
  },
}

export default skillUpCareerProvider
